import { Unit, UnitSettings } from '@schenck/rotec-components';

export const UNIT_FAMILY: string[] = ['coupleUnbalance', 'unbalance', 'mass'];

export const UNITS_MAPPERS: { [key: string]: string } = {
  EPhysUnit_Mass: 'massValue',
  EPhysUnit_Length: 'lengthValue',
  EPhysUnit_Unbalance: 'unbalanceValue',
  EPhysUnit_Frequency: 'nominalSpeedValue',
  EPhysUnit_Density: 'densityValue',
  EPhysUnit_Time: 'timeValue',
};

export const SI_UNITS_SYMBOLS: { [key: string]: Unit } = {
  EPhysUnit_Mass: 'kg',
  EPhysUnit_Length: 'm',
  EPhysUnit_Unbalance: 'kg·m',
  EPhysUnit_Frequency: '1/s',
  EPhysUnit_Density: 'kg/m³',
  EPhysUnit_Time: 'sec',
};

export const SI_UNITS_INDEX: { [key: string]: number } = {
  EPhysUnit_Mass: 3,
  EPhysUnit_Length: 3,
  EPhysUnit_Unbalance: 6,
  EPhysUnit_Frequency: 1,
  EPhysUnit_Density: 0,
  EPhysUnit_Time: 1,
};

export const SI_UNITS: UnitSettings = {
  lengthValue: 'm',
  massValue: 'kg',
  nominalSpeedValue: '1/s',
  unbalanceValue: 'kg·m',
  densityValue: 'kg/m³',
  isUnbalanceAsMass: false,
  timeValue: 'sec',
};
